import { useComposedRefs } from "../../utils/use-composed-refs.js";
import { renderElement } from "../../utils/use-render.js";
import { useThumbnailContext } from "./context.js";
import { forwardRef } from "react";
//#region src/ui/thumbnail/image.tsx
/**
* Displays the image selected and measured by `Thumbnail.Root`.
*
* Renders an `img`, so native image attributes and the `render` escape hatch remain available without replacing the
* root that owns thumbnail state.
*/
const ThumbnailImage = forwardRef(function ThumbnailImage(componentProps, forwardedRef) {
	const { render, className, style, crossOrigin, loading, fetchPriority, ...elementProps } = componentProps;
	const { core, state, src, imageStyle, inheritedCrossOrigin, imageRef } = useThumbnailContext();
	const ref = useComposedRefs(forwardedRef, imageRef);
	return renderElement("img", {
		render,
		className,
		style
	}, {
		state,
		ref,
		props: [
			{
				alt: "",
				"aria-hidden": "true",
				decoding: "async"
			},
			elementProps,
			{
				src,
				crossOrigin: core.resolveCrossOrigin(crossOrigin, inheritedCrossOrigin),
				loading,
				style: imageStyle,
				fetchPriority
			}
		]
	});
});
//#endregion
export { ThumbnailImage };

//# sourceMappingURL=image.js.map